<template>
  <div class="loginpage-container pa-0"
       @keyup.enter="login">
    <div class="loginpage">

      <div class="semanticsection-title2 primary--text">Anmelden
      </div>

      <form class="loginfields">

        <v-text-field v-model.trim="username"
                      v-validate="'required'"
                      :error-messages="errors.collect('loginname')"
                      autofocus
                      name="loginname"
                      data-vv-as="Benutzername"
                      label="Benutzername/Vermittlernummer"
                      hint="Benutzername oder Vermittlernummer"
                      autocomplete="username"
                      class="required" />

        <v-text-field v-model="password"
                      v-validate="'required'"
                      :error-messages="errors.collect('password')"
                      data-vv-as="Passwort"
                      name="password"
                      label="Passwort"
                      type="password"
                      autocomplete="current-password"
                      class="required" />

      </form>

      <v-btn id="loginbutton"
             :disabled="isloading"
             color="primary white--text"
             @click="login">Login
      </v-btn>

      <div id="login-info">
        Neuer Makler?
        <router-link :to="'/register'">Jetzt registrieren.</router-link>
        <br>
        <router-link :to="'/passwordlost'">Passwort vergessen?</router-link>
      </div>

    </div>

    <v-snackbar v-model="loginerror"
                :timeout="15000"
                color="error">
      <span class="text-center">
        <v-icon color="white">warning</v-icon>&nbsp;{{ errormessage }}</span>
    </v-snackbar>

  </div>
</template>


<script>
import ValidationMixin from "@/components/helper/ValidationMixin";
import httpService from '../../helper/httpService';
//import dummyUser from "@/store/dummyData/dummyUser";
const MSG_INVALID_CREDENTIALS = "Benutzername oder Passwort falsch.";
const MSG_LOGIN_FORBIDDEN = "Als Poolmakler melden Sie sich bitte ausschließlich per SingleSignOn über das Portal ihres Maklerpools an! Die Anmeldung mit Username & Passwort ist für Ihren Pool nicht möglich.";
const MSG_NO_BIPRO ="Sie haben gerade versucht, sich mit BiPRO-Benutzerdaten im DMB Rechtsschutz Maklerportal anzumelden. Bitte verwenden Sie stattdessen Ihre Maklerportal-Zugangsdaten!";
export default {
  mixins: [ValidationMixin],
  data: function () {
    return {
      username: "",
      password: "",
      loginerror: false,
      isloading: false,
      errormessage: MSG_INVALID_CREDENTIALS
    };
  },
  computed: {
    firstLogin() {
      return this.$store.getters.firstLogin;
    }
  },
  methods: {
    login: function () {
      this.isloading = true;
      this.loginerror = false;
      this.$validator.validateAll()
        .then((result) => {
          if (!result) throw new Error();
          return httpService.login({ username: this.username, password: this.password });
        })
        .then(user => {
          this.$store.commit("setUser", user);
          return httpService.getWhoAmI();
        })
        .then(user => {
          this.isloading = false;
          this.$store.commit("setUser", user);
          this.$store.commit("resetStaticUserContent");
          this.$router.push(this.firstLogin ? '/onboarding' : '/start');
        })
        .catch((err) => {
          this.loginerror = true;
          this.isloading = false;
          try {
            if(this.username.toLowerCase().startsWith("bi_") || this.username.toLowerCase().startsWith("dmbrsv-")){
              this.errormessage = MSG_NO_BIPRO;
            } else {
              this.errormessage = err.body.d.Message === "Login forbidden" ? MSG_LOGIN_FORBIDDEN : MSG_INVALID_CREDENTIALS;
            }
          }
          catch (e) {
            this.errormessage = err.message;
          }
          // Enable this section to disable Authentication in development mode and import dummyUser from "@/store/dummyData/dummyUser" (line ~63 above);
          /* if (this.$store.state.env.environment === 'development' && err.status !== undefined) {
             this.$store.commit('setUser', dummyUser);
             this.$store.commit("resetStaticUserContent");
             this.$router.push(this.firstLogin ? '/onboarding' : '/start');
           } */
        });
    }
  }
};
</script>
<style>

.loginpage-container {
  margin: 0 48px 100px 48px;
  display: flex;
  justify-content: center;
}

.loginpage {
  max-width: 768px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.loginpage > * {
  margin-left: auto;
  margin-right: auto;
}

.loginpage .loginfields {
  width: 344px;
  margin: 0 auto;
}

.loginpage #loginbutton {
  margin: 24px auto 40px auto;
}

.loginpage #loginbutton.btn.btn--disabled {
  color: white !important;
  background-color: #0085CF !important;
}

#login-info {
  text-align: center;
}

</style>
